import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Local development runs in Angular dev mode so change-detection violations
// (NG0100) surface as errors instead of being silently masked. Deployed
// builds (dev/test/live) run in prod mode for performance.
if (environment.env !== 'local') {
  enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
